import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Products from './pages/Products';
import Settings from './pages/Settings';
import HeroSlides from './pages/HeroSlides';
import Categories from './pages/Categories';
import Cities from './pages/Cities';
import Appointments from './pages/Appointments';
import Reviews from './pages/Reviews';
import Content from './pages/Content';
import Blog from './pages/Blog';
import SEO from './pages/SEO';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div style={{ padding: 32 }}>Loading…</div>;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div style={{ padding: 32 }}>Loading…</div>;
  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />;
};

const wrap = (Page) => (
  <ProtectedRoute>
    <Layout>
      <Page />
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/dashboard" element={wrap(Dashboard)} />
          <Route path="/orders" element={wrap(Orders)} />
          <Route path="/users" element={wrap(Users)} />
          <Route path="/customers" element={wrap(Customers)} />
          <Route path="/products" element={wrap(Products)} />
          <Route path="/categories" element={wrap(Categories)} />
          <Route path="/cities" element={wrap(Cities)} />
          <Route path="/appointments" element={wrap(Appointments)} />
          <Route path="/reviews" element={wrap(Reviews)} />
          <Route path="/hero-slides" element={wrap(HeroSlides)} />
          <Route path="/content" element={wrap(Content)} />
          <Route path="/blog" element={wrap(Blog)} />
          <Route path="/seo" element={wrap(SEO)} />
          <Route path="/settings" element={wrap(Settings)} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
